import axiosInstance from './utils/axiosConfig';

export const refreshToken = async (retryCount = 0) => {
  // Add a flag to prevent multiple simultaneous refreshes
  if (window.isRefreshing) {
    return null;
  }
  
  // Maximum retry attempts
  const maxRetries = 2;
  
  try {
    window.isRefreshing = true;
    
    // Check if we have a current token before attempting refresh
    const currentToken = window.localStorage.getItem('JWT_TOKEN');
    if (!currentToken) {
      console.log('No current token found, cannot refresh');
      return null;
    }
    
    console.log(`Token refresh attempt ${retryCount + 1}`);
    const response = await axiosInstance.post(`/auth/refresh`);
    
    if (response.data?.access_token) {
      window.localStorage.setItem("JWT_TOKEN", response.data.access_token);
      console.log('Token refresh successful');
      return response.data.access_token;
    } else {
      console.warn('Token refresh response missing access_token');
      return null;
    }
  } catch (error) {
    console.error(`Token refresh failed (attempt ${retryCount + 1}):`, error);
    
    // Retry on network errors but not on auth errors
    if (retryCount < maxRetries && 
        error.code === 'NETWORK_ERROR' || 
        error.response?.status >= 500) {
      console.log(`Retrying token refresh in 2 seconds...`);
      await new Promise(resolve => setTimeout(resolve, 2000));
      return refreshToken(retryCount + 1);
    }
    
    return null;
  } finally {
    window.isRefreshing = false;
  }
};

export const checkTokenValidity = async () => {
  try {
    const currentToken = window.localStorage.getItem('JWT_TOKEN');
    
    if (!currentToken) {
      console.log('No token found for validity check');
      return false;
    }
    
    const response = await axiosInstance.get(`/auth/verify-token`, {
      headers: {
        'Authorization': `Bearer ${currentToken}`
      }
    });
    
    return response.status === 200;
  } catch (error) {
    console.error('Token verification failed', error);
    return false;
  }
};